<div *ngIf="view.kind === 'paymentFailed'" class="bb bb--red" role="alert">
    <span class="bb-icon"><lucide-icon name="credit-card" [size]="16" class="no-fill"></lucide-icon></span>
    <span class="bb-text"><strong>{{ view.lead }}</strong>{{ view.rest }}</span>
    <button type="button" class="bb-btn bb-btn--red" [disabled]="busy" (click)="updateCard()">Update card</button>
</div>

<div *ngIf="view.kind === 'cancelPending'" class="bb bb--yellow" role="status">
    <span class="bb-icon"><lucide-icon name="calendar" [size]="16" class="no-fill"></lucide-icon></span>
    <span class="bb-text"><strong>{{ view.lead }}</strong>{{ view.rest }}</span>
    <button type="button" class="bb-btn bb-btn--yellow" [disabled]="busy" (click)="keepPlan()">Keep my plan</button>
</div>
